import { Checkbox } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import InfoItem from "../InfoItem";
import dateFormat from "dateformat";
import "./OrderDetailsCard.css";
import FirstServicesIcons from "../../assets/svg/FirstServiceIcon.svg";
import SecondServicesIcons from "../../assets/svg/SecondServiceIcon.svg";
import { formatNumber } from "../../hooks/formatNumber";

function TransferOrders({
  setTransferOrders,
  transferOrders,
  vanProfileOrdersData,
  setSlectedtransferOrders,
  setShowSelectTheVan,
}) {
  const handleCloseAddOrder = () => {
    setTransferOrders(false);
  };
  //Van Profile
  const [vanOrdersData, setvanOrdersData] = useState(
    (prev) => (prev = vanProfileOrdersData)
  );

  useEffect(() => {
    // getTreansferOrdersData();
    console.log(vanOrdersData);
  }, [vanOrdersData]);

  // const getTreansferOrdersData = () => {
  //   const headers = {
  //     Authorization:
  //       "Bearer 338|URoHV9kMvJABmgvvrUzTxexaQhMfPL1FmyVCvRrEabef1878",
  //   }; // auth header with bearer token

  //   axios
  //     .get(
  //       `${GET_ALL_VEHICLE_ORDERS}?vehicle_id=${window.location.href
  //         .split("/")
  //         .at(-1)}`,
  //       { headers }
  //     )
  //     .then((response) => {
  //       //data message success
  //       console.log(vanOrdersData);
  //       console.log(response.data.data?.order);

  //       if (response.data.data?.order !== undefined) {
  //         // setvanOrdersData((perv) => (perv = response.data.data.order));
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error.message);
  //     });
  // };

  //Select the orders

  const [checked_TrtnsferOrder, setChecked_TrtnsferOrder] = useState([]);
  const handleChange_TrtnsferOrder = (key) => {
    if (checked_TrtnsferOrder.filter((e) => e === key)[0]) {
      setChecked_TrtnsferOrder(checked_TrtnsferOrder.filter((e) => e !== key));
      return;
    }
    setChecked_TrtnsferOrder((prev) => [...prev, key]);
  };
  const [checkedAllOrders_TrtnsferOrder, setCheckedAllOrders_TrtnsferOrder] =
    useState(false);
  const handleCheckedAllOrders_TrtnsferOrder = (event) => {
    if (event.target.checked === false) {
      setCheckedAllOrders_TrtnsferOrder(false);
      setChecked_TrtnsferOrder([]);
      return;
    }
    setCheckedAllOrders_TrtnsferOrder(event.target.checked || true);
    setChecked_TrtnsferOrder(vanOrdersData.map((e) => (e.id ? e.id : null)));
  };

  //Sabmit the orders
  const SabmitTransferOrders = () => {
    const ordersTransfer = vanOrdersData.filter((e) =>
      checked_TrtnsferOrder.includes(e.id)
    );
    setSlectedtransferOrders(ordersTransfer);
    setTransferOrders(false);
    setShowSelectTheVan(true);
  };

  return (
    <Modal
      show={transferOrders}
      fullscreen={"xl-down"}
      contentClassName="m-content"
      dialogClassName="m-dialog"
      onHide={handleCloseAddOrder}
    >
      <Modal.Header className="AddStaffModal_header">
        <Modal.Title className="AddStaffModal_title">
          Transfer Orders
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="transferOrdersRow1">
          <Checkbox
            className="p-0 widthMinWidth"
            checked={checkedAllOrders_TrtnsferOrder}
            onChange={(e) => handleCheckedAllOrders_TrtnsferOrder(e)}
          />
          <div className="SelectAllTextTransferOrders">Select all orders</div>
        </div>
        {vanOrdersData?.map((e) => {
          return (
            <>
              <div key={e.id} className=" orderTransfer">
                <Checkbox
                  style={{ width: "min-width" }}
                  className="p-0"
                  checked={
                    checked_TrtnsferOrder.filter((key) => key === e.id)[0]
                      ? true
                      : false
                  }
                  onChange={() => handleChange_TrtnsferOrder(e.id)}
                />
                <div className="main-Order">
                  <div
                    className="accordion"
                    id="accordionPanelsStayOpenExample "
                  >
                    <div className="accordion-item">
                      <h2 className="accordion-header " id={`${e.id}-head`}>
                        <button
                          className={`accordion-button bg-light text-dark btn-xs buttons`}
                          type="button"
                          data-bs-toggle={`collapse`}
                          data-bs-target={`#${e.id}`}
                          aria-expanded="false"
                          aria-controls={`${e.id}`}
                        >
                          <div className="row justify-content-between w-100">
                            <div className="col-8">
                              Order
                              <span className="fw-bold g-1 text-dark m-2">
                                #{e.id}
                              </span>
                            </div>
                            <div className="col-4 d-flex justify-content-end">
                              <span className="text-dark fw-bold">
                                { formatNumber(e.total_price)} EGP
                              </span>
                            </div>
                          </div>
                        </button>
                      </h2>
                      <div
                        id={e.id}
                        className="accordion-collapse collapse"
                        aria-labelledby={`${e.id}-head`}
                      >
                        <div className="accordion-body">
                          <ul className="list-group list-group-flush">
                            <li className="list-group-item ">
                              <div className="row ">
                                <li className=" fw-600 col-4">
                                  <div className=" mx-2">
                                    <InfoItem
                                      label="Date:"
                                      value={dateFormat(
                                        e.updated_at,
                                        "fullDate"
                                      )}
                                    />
                                    <InfoItem label="Payment:" value="Cash" />
                                  </div>
                                </li>
                                <li className="list-group-item fw-600 col-8 border-0">
                                  <div>
                                    <InfoItem
                                      label="Time:"
                                      value={
                                        e.reservation
                                          ? `${e.reservation.from} - ${e.reservation.to}`
                                          : "Not Found"
                                      }
                                    />
                                    <InfoItem
                                      label="Location:"
                                      style={{
                                        width: "min-width",
                                        overflow: "hidden",
                                      }}
                                      value={
                                        e.address
                                          ? `${e.address.address}`
                                          : "Not Found"
                                      }
                                    />
                                  </div>
                                </li>
                                <li className="list-group-item fw-600 col-6 border-0 mx-2">
                                  <div>
                                    <InfoItem
                                      label="Car Model:"
                                      value={e?.car?.name}
                                    />
                                  </div>
                                </li>
                              </div>
                            </li>
                            <li className="list-group-item  ">
                              <h4 className="fs-5">
                                <img src={FirstServicesIcons} />
                                Oil Services
                              </h4>
                              <div>
                                <div className="row">
                                  <h6
                                    style={{
                                      fontWeight: "400px",
                                      color: "#535353",
                                    }}
                                  >
                                    Check Oil
                                  </h6>
                                  <div className="row mt-3">
                                    <div className="col-md-10 col-sm-12 col-xs-12">
                                      <div className="in-block">
                                        <ul className="p-0 m-0 in-block">
                                          <li>
                                            <span className="grayColor">
                                              Oil Leack:
                                            </span>
                                            <span className="itemInfo">
                                              200 EGP
                                            </span>
                                          </li>
                                        </ul>
                                      </div>
                                      <div className="in-block ml-4">
                                        <ul className="p-0 m-0 in-block">
                                          <li>
                                            <span className="grayColor">
                                              Check Engine Oil:
                                            </span>
                                            <span className="itemInfo">
                                              100 EGP
                                            </span>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                    <div className="col-md-2 col-sm-12 col-xs-12 text-right p-0 m-0">
                                      <h6 className="fw-bold">1000 EGP </h6>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div>
                                <div className="row">
                                  <h6
                                    style={{
                                      fontWeight: "400px",
                                      color: "#535353",
                                    }}
                                  >
                                    Change Oil
                                  </h6>
                                  <div className="row mt-3">
                                    <div className="col-md-10 col-sm-12 col-xs-12">
                                      <div className="in-block">
                                        <ul className="p-0 m-0 in-block">
                                          <li>
                                            <span className="grayColor">
                                              Oil Brand:
                                            </span>
                                            <span className="itemInfo">
                                              Shell
                                            </span>
                                          </li>
                                        </ul>
                                      </div>

                                      <div className="in-block ml-4">
                                        <ul className="p-0 m-0 in-block">
                                          <li>
                                            <span className="grayColor">
                                              Oil Viscosity:
                                            </span>
                                            <span className="itemInfo">
                                              5W - 30
                                            </span>
                                          </li>
                                        </ul>
                                      </div>

                                      <div className="in-block ml-4">
                                        <ul className="p-0 m-0 in-block">
                                          <li>
                                            <span className="grayColor">
                                              Oil Liters:
                                            </span>
                                            <span className="itemInfo">5L</span>
                                          </li>
                                        </ul>
                                      </div>

                                      <div className="in-block ml-4">
                                        <ul className="p-0 m-0 in-block">
                                          <li>
                                            <span className="grayColor">
                                              Oil Filter:
                                            </span>
                                            <span className="itemInfo">
                                              Bosh
                                            </span>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>

                                    <div className="col-md-2 col-sm-12 col-xs-12 text-right p-0 m-0">
                                      <h6 className="fw-bold">1000 EGP </h6>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </li>
                            <li className="list-group-item ">
                              <h4 className="fs-5">
                                <img src={SecondServicesIcons} />
                                Tire Services
                              </h4>
                              <div>
                                <div className="row">
                                  <h6
                                    style={{
                                      fontWeight: "400px",
                                      color: "#535353",
                                    }}
                                  >
                                    Change Tire
                                  </h6>
                                  <div className="row mt-3">
                                    <div className="col-md-10 col-sm-12 col-xs-12">
                                      <div className="in-block">
                                        <ul className="p-0 m-0 in-block">
                                          <li>
                                            <span className="grayColor">
                                              Type:
                                            </span>
                                            <span className="itemInfo">
                                              Tubeless
                                            </span>
                                          </li>
                                        </ul>
                                      </div>

                                      <div className="in-block ml-4">
                                        <ul className="p-0 m-0 in-block">
                                          <li>
                                            <span className="grayColor">
                                              Brand:
                                            </span>
                                            <span className="itemInfo">
                                              Pirelli
                                            </span>
                                          </li>
                                        </ul>
                                      </div>

                                      <div className="in-block ml-4">
                                        <ul className="p-0 m-0 in-block">
                                          <li>
                                            <span className="grayColor">
                                              Made in:
                                            </span>
                                            <span className="itemInfo">5L</span>
                                          </li>
                                        </ul>
                                      </div>

                                      <div className="in-block ml-4">
                                        <ul className="p-0 m-0 in-block">
                                          <li>
                                            <span className="grayColor">
                                              Number of tires:
                                            </span>
                                            <span className="itemInfo">
                                              1 tire
                                            </span>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>

                                    <div className="col-md-2 col-sm-12 col-xs-12 text-right p-0 m-0">
                                      <h6 className="fw-bold">4000 EGP </h6>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        })}
        <div className="OrdersTable-footer">
          <button
            disabled={checked_TrtnsferOrder.length < 1}
            onClick={SabmitTransferOrders}
            className="ordersSaveTable"
          >
            Select a van
          </button>
          <button onClick={handleCloseAddOrder} className="ordersCancelTable">
            Cancel
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default TransferOrders;
